export const SET_CONTENT_VIEW_OPTION = 'SET_CONTENT_VIEW_OPTION';
export const setContentViewOption = value => ({ type: SET_CONTENT_VIEW_OPTION, value });

export const TOGGLE_CONTENT_VIEW_OPTION = 'TOGGLE_CONTENT_VIEW_OPTION';
export const toggleContentViewOption = value => ({ type: TOGGLE_CONTENT_VIEW_OPTION, value });



// WEBPACK FOOTER //
// ./src/actions/options.js